import { render, staticRenderFns } from "./SuitabilityForm.vue?vue&type=template&id=a011035e"
import script from "./SuitabilityForm.vue?vue&type=script&lang=ts"
export * from "./SuitabilityForm.vue?vue&type=script&lang=ts"
import style0 from "./SuitabilityForm.vue?vue&type=style&index=0&id=a011035e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports